export enum ShippingTypeEnum {
    DISTRIBUTION_CENTER = "DISTRIBUTION_CENTER",
    DIRECT = "DIRECT"
}
